import React from 'react';

const TaxonomyModal = (props) => {
    const {
        title,
        icons
    } = props;

    return (
        <div className="taxonomy-modal">
            <div className="taxonomy-modal__container">
                <div className="taxonomy-modal__wrapper">
                    <div className="taxonomy-modal__header">
                        {title && title.length > 0 &&
                            <div className="taxonomy-modal__title">
                                <div className="has-line position-left">
                                    <h2>{title}</h2>
                                </div>
                            </div>
                        }
                        <button className="taxonomy-modal__close" data-modal-close onClick={() => closeModal()}></button>
                    </div>
                    {icons && icons.length > 0 &&
                        <div className="taxonomy-modal__icons">
                            {icons.map((item, index) => {
                                return (
                                    <div
                                        className="taxonomy-modal__icons-item"
                                        key={index}
                                    >
                                        <figure dangerouslySetInnerHTML={{ __html: item.icon }}></figure>
                                        <div
                                            className="taxonomy-modal__icons-content"
                                            dangerouslySetInnerHTML={{ __html: item.content }}>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    }
                </div>
            </div>
        </div>
    )

    function closeModal() {
        event.preventDefault();
        const modalWrapper = document.querySelector('.taxonomy-modal');
    
        if (modalWrapper) {
          modalWrapper.classList.remove('taxonomy-modal--active');
          document.body.style.overflow = '';
        }
      }
}

export default TaxonomyModal;